import { useEffect, useRef } from 'react'
import { MetaPixelResolved, trackMetaPageView } from '../utils/metaPixel'

/**
 * Dispara `PageView` una sola vez por cada Pixel realmente resuelto.
 *
 * El `ref` recuerda el último Pixel ID para el que ya se disparó: si el
 * componente vuelve a renderizarse por cualquier otro motivo (estado no
 * relacionado, doble invocación de React en desarrollo…) sin que el Pixel
 * cambie, el evento NO se repite. Solo se dispara de nuevo si `resolved`
 * cambia de verdad (por ejemplo, al navegar a una landing distinta), que es
 * exactamente lo que corresponde a una página nueva.
 */
export function useMetaPixelPageView(resolved: MetaPixelResolved): void {
  const firedFor = useRef<string | null>(null)

  useEffect(() => {
    if (!resolved.enabled || !resolved.pixelId) return
    if (firedFor.current === resolved.pixelId) return
    firedFor.current = resolved.pixelId
    trackMetaPageView(resolved)
    // Solo debe reaccionar a cambios reales del Pixel resuelto.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resolved.enabled, resolved.pixelId])
}
